import type { Thread } from "./protocol";

export function startTurn(thread: Thread, text: string, modelSelection?: Record<string, unknown>) {
  return {
    type: "thread.turn.start",
    commandId: crypto.randomUUID(),
    threadId: thread.id,
    message: {
      messageId: crypto.randomUUID(),
      role: "user",
      text,
      attachments: [],
    },
    modelSelection: modelSelection ?? thread.modelSelection ?? {
      provider: "codex",
      model: "gpt-5",
    },
    runtimeMode: thread.runtimeMode ?? "full-access",
    interactionMode: thread.interactionMode ?? "default",
    createdAt: new Date().toISOString(),
  };
}

export function interruptTurn(threadId: string, turnId?: string) {
  return {
    type: "thread.turn.interrupt",
    commandId: crypto.randomUUID(),
    threadId,
    ...(turnId ? { turnId } : {}),
    createdAt: new Date().toISOString(),
  };
}

export function respondToApproval(threadId: string, requestId: string, decision: "approve" | "reject") {
  return {
    type: "thread.approval.respond",
    commandId: crypto.randomUUID(),
    threadId,
    requestId,
    decision,
    createdAt: new Date().toISOString(),
  };
}

export function respondToUserInput(threadId: string, requestId: string, answers: unknown[]) {
  return {
    type: "thread.user-input.respond",
    commandId: crypto.randomUUID(),
    threadId,
    requestId,
    answers,
    createdAt: new Date().toISOString(),
  };
}

export function createProject(
  title: string,
  workspaceRoot: string,
  modelSelection: Record<string, unknown>,
) {
  const projectId = crypto.randomUUID();
  const threadId = crypto.randomUUID();
  const createdAt = new Date().toISOString();
  return [
    {
      type: "project.create",
      commandId: crypto.randomUUID(),
      projectId,
      title: title.trim() || "Project",
      workspaceRoot,
      createWorkspaceRootIfMissing: true,
      defaultModelSelection: modelSelection,
      createdAt,
    },
    {
      type: "thread.create",
      commandId: crypto.randomUUID(),
      threadId,
      projectId,
      title: "New thread",
      modelSelection,
      runtimeMode: "full-access",
      interactionMode: "default",
      branch: null,
      worktreePath: workspaceRoot,
      createdAt,
    },
  ];
}
